import Logo from './Logo'
import SearchBar from './SearchBar'
import UploadButton from './UploadButton'
import Filter from './Filter'
import {Stack, Box } from '@mui/material'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'

export default function Header(props){
    const {id} = useParams()
    
    return(
        <div className="Header">
            <StyledStack>
                <Stack direction="row" justifyContent="space-between" alignItems='center'>
                    <Logo/>
                    { !id && <SearchBar/>}
                    <UploadButton/>
                </Stack>
                { !id && <Filter/>}
            </StyledStack>
        </div>
    )
}

const StyledStack = styled(Stack)`
    background: #313131;
    padding: 0.5rem 1rem;
    position: -webkit-sticky;
    top: 0;
`

export {
    Logo, 
    SearchBar,
    UploadButton
}